import games from "./games.JPG";
import store from "./QueryStore.JPG"



export const Projects = [

    {
        title: "Query Store",
        website: "https://query-store.vercel.app/",
        Image:store,
        tag1: "React Query",
        tag2:  "Axios",
        tag3:  "React Router",
        tag4:  " Rest Api",
 
    },
    {
        title: "GamesMode", 
        website: "https://gamesmode-vercel.vercel.app",
        Image:games,
        tag1: "React Router",
        tag2:  "Components",
        tag3:  "UI Design",
        tag4:  "Frontend",

    },   
    
]

